import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Store } from '@ngrx/store';
import * as RtMapSelectors from '../../../../../redux/selectors/rtmap.selectors';

@Component({
  selector: 'app-rt-map-counters',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './rt-map-counters.component.html',
  styleUrls: ['./rt-map-counters.component.css']
})
export class RtMapCountersComponent {
  totalPartners$ = this.store.select(RtMapSelectors.selectTotalPartners);
  activePartners$ = this.store.select(RtMapSelectors.selectTotalActivePartners);
  inactivePartners$ = this.store.select(RtMapSelectors.selectTotalInactivePartners);

  constructor(private store: Store) {}
}
